export const PHOTON_MIN_QUERY_LENGTH = 4
export const PHOTON_SEARCH_DELAY = 1000
export const PHOTON_API_URL = process.env.VUE_APP_PHOTON_API_URL || 'https://photon.manet-marketing.de/api/'
export const DEFAULT_MAP_VIEW = [53.76666667, 12.566666667]
export const DEFAULT_MAP_ZOOM = 7

export function shouldSearchPhoton(query = '') {
  return query.trim().length >= PHOTON_MIN_QUERY_LENGTH
}

export function buildPhotonSearchUrl(query, lang = 'de') {
  const url = new URL(PHOTON_API_URL)
  url.searchParams.set('q', query)
  url.searchParams.set('lang', lang)
  return url.toString()
}

export function filterPhotonHouseResults(features = []) {
  return features.filter((feature) => feature?.properties?.type === 'house')
}

export function formatPhotonFeatureLabel(feature) {
  const street = [feature?.properties?.street, feature?.properties?.housenumber].filter(Boolean).join(' ')
  const parts = [
    feature?.properties?.name ? `${feature.properties.name},` : null,
    street ? `${street},` : null,
    feature?.properties?.postcode,
    feature?.properties?.city,
    feature?.properties?.district ? `(${feature.properties.district})` : null,
  ]

  return parts.filter(Boolean).join(' ')
}

export function formatPhotonFeatureTitle(feature) {
  return [feature?.properties?.street, feature?.properties?.housenumber].filter(Boolean).join(' ')
}

export function formatPhotonFeatureSubtitle(feature) {
  const location = [feature?.properties?.postcode, feature?.properties?.city].filter(Boolean).join(' ')
  return [location, feature?.properties?.state].filter(Boolean).join(', ')
}

export function mapPhotonFeatureToAddress(feature) {
  const streetParts = [feature?.properties?.street, feature?.properties?.housenumber].filter(Boolean)

  return {
    street: streetParts.length ? streetParts.join(' ') : feature?.properties?.name || '',
    postcode: feature?.properties?.postcode,
    city: feature?.properties?.city,
    country: feature?.properties?.country,
    lat: feature?.geometry?.coordinates?.[1],
    lon: feature?.geometry?.coordinates?.[0],
  }
}
